// extracted by mini-css-extract-plugin
export default {"statConn":"Doughnut_statConn__fpTnN","containerConn":"Doughnut_containerConn__o2m2c"};